export default "__VITE_ASSET__DxlmEGlA__"